import {
  configurationRegex,
  digitOnly,
  emailRegex,
  passwordRegex,
  registerNumberRegex,
  stringRegex,
} from "../../../statics/validators";
import {
  CreateWorkspaceWizardData,
  StepErrors,
} from "../types/create-workspace-wizard";

export function validateStep1(
  data: CreateWorkspaceWizardData["step1"],
): StepErrors | null {
  const e: StepErrors = {};
  if (!data.name?.trim()) e.name = "REQUIRED";
  else if (!stringRegex.test(data.name)) e.name = "INVALID";

  if (!data.register_number?.trim()) e.register_number = "REQUIRED";
  else if (!registerNumberRegex.test(data.register_number))
    e.register_number = "INVALID";

  if (!data.address?.trim()) e.address = "REQUIRED";
  else if (!stringRegex.test(data.address)) e.address = "INVALID";

  if (!data.postal_code?.trim()) e.postal_code = "REQUIRED";
  else if (!digitOnly.test(data.postal_code)) e.postal_code = "INVALID";

  if (!data.city?.trim()) e.city = "REQUIRED";
  else if (!stringRegex.test(data.city)) e.city = "INVALID";

  if (!data.email?.trim()) e.email = "REQUIRED";
  else if (!emailRegex.test(data.email)) e.email = "INVALID";

  if (!data.technical_contact_email?.trim())
    e.technical_contact_email = "REQUIRED";
  else if (!emailRegex.test(data.technical_contact_email))
    e.technical_contact_email = "INVALID";

  if (!data.organization_contact_email?.trim())
    e.organization_contact_email = "REQUIRED";
  else if (!emailRegex.test(data.organization_contact_email))
    e.organization_contact_email = "INVALID";

  return Object.keys(e).length ? e : null;
}

export function validateStep2(
  data: CreateWorkspaceWizardData["step2"],
): StepErrors | null {
  const e: StepErrors = {};
  if (!data.workspace?.trim()) e.workspace = "REQUIRED";
  else if (!stringRegex.test(data.workspace)) e.workspace = "INVALID";

  if (!data.configurationName?.trim()) e.configurationName = "REQUIRED";
  else if (!configurationRegex.test(data.configurationName))
    e.configurationName = "INVALID";

  if (!data.defaultPassword?.trim()) e.defaultPassword = "REQUIRED";
  else if (!passwordRegex.test(data.defaultPassword))
    e.defaultPassword = "INVALID";

  if (!data.logoFile) e.logoPreviewUrl = "REQUIRED";

  return Object.keys(e).length ? e : null;
}

export function validateStep3(
  data: CreateWorkspaceWizardData["step3"],
): StepErrors | null {
  const e: StepErrors = {};
  if (!data.coordinatorFirstName?.trim()) e.coordinatorFirstName = "REQUIRED";
  else if (!stringRegex.test(data.coordinatorFirstName))
    e.coordinatorFirstName = "INVALID";

  if (!data.coordinatorLastName?.trim()) e.coordinatorLastName = "REQUIRED";
  else if (!stringRegex.test(data.coordinatorLastName))
    e.coordinatorLastName = "INVALID";

  if (!data.coordinatorEmail?.trim()) e.coordinatorEmail = "REQUIRED";
  else if (!emailRegex.test(data.coordinatorEmail))
    e.coordinatorEmail = "INVALID";

  if (!data.coordinatorCompany?.trim()) e.coordinatorCompany = "REQUIRED";
  else if (!stringRegex.test(data.coordinatorCompany))
    e.coordinatorCompany = "INVALID";

  if (!data.coordinatorSubscription) e.coordinatorSubscription = "REQUIRED";
  return Object.keys(e).length ? e : null;
}
